export function HIcon({
  className = "size-4",
}: {
  className?: string;
}) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M4.00008 2.66699V13.3337M12.0001 2.66699V13.3337M5.33341 2.66699H2.66675M12.0001 8.00033L4.00008 8.00033M5.33341 13.3337H2.66675M13.3334 13.3337H10.6667M13.3334 2.66699H10.6667" stroke="#101828" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "ClearIcon";
